import { Component, Input, OnInit } from '@angular/core';
import { CondoUser } from '@api/model/condo-user';
import { UserService } from '@api/service/user.service';
import { ActivatedRoute } from '@angular/router';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { ModalEditEmailComponent } from '../../../components/modal-edit-email/modal-edit-email.component';
import { ModalResetUserPasswordComponent } from '../../../components/modal-reset-user-password/modal-reset-user-password.component';
import { AuthToken } from '@api/model/auth-token';
import { EcondosQuery } from '@api/model/query';
import { firstValueFrom } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-user-details-page',
  templateUrl: './user-details-page.component.html',
  styleUrls: ['./user-details-page.component.scss']
})
export class UserDetailsPageComponent implements OnInit {
  @Input() userIdModal?: string;

  userId: string = '';

  connectedDevices: AuthToken[] = [];
  total = 0;

  nzPageSize = 10;
  nzPageIndex = 0;

  status: 'LOADING' | 'SUCCESS' | 'ERROR' | null = 'LOADING';

  constructor(
    private userService: UserService,
    public route: ActivatedRoute,
    private modalService: NzModalService
  ) {
    this.route.paramMap.pipe(takeUntilDestroyed()).subscribe(p => (this.userId = p.get('userId')!));
  }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    const query: EcondosQuery = {
      $page: this.nzPageIndex,
      $limit: this.nzPageSize
    };

    this.userService.getUserTokens(this.userId, query).subscribe({
      next: ({ count, authTokens }) => {
        this.connectedDevices = authTokens;
        this.total = count;

        this.status = 'SUCCESS';
      },
      error: err => {
        console.log(err);
        this.status = 'ERROR';
      }
    });
  }

  showModalUpdateEmail(user?: CondoUser): void {
    const modal: NzModalRef = this.modalService.create({
      nzTitle: 'Editar Email',
      nzContent: ModalEditEmailComponent,
      nzData: { user },
      nzFooter: [{ label: 'Close', type: 'primary', onClick: () => modal.destroy() }]
    });
  }

  showModalResetPassword(user?: CondoUser): void {
    const modal: NzModalRef = this.modalService.create({
      nzTitle: 'Resetar Senha',
      nzContent: ModalResetUserPasswordComponent,
      nzData: { user },
      nzFooter: [{ label: 'Close', type: 'default', onClick: () => modal.destroy() }]
    });
  }

  disconnectDevice(authToken: string) {
    this.modalService.confirm({
      nzTitle: 'Desconectar dispositivo',
      nzContent: 'Tem certeza que deseja desconectar este dispositivo?',
      nzOkText: 'Sim',
      nzCancelText: 'Cancelar',
      nzOkType: 'primary',
      nzOnOk: async () => {
        this.status = 'LOADING';
        try {
          await firstValueFrom(this.userService.deleteUserToken(this.userId, authToken));
          this.getData();
        } catch (error) {
          this.getData();
          const errorMessage = error instanceof Error ? error.message : 'Não foi possível desconectar esse dispositivo, tente novamente.';
          this.modalService.error({
            nzTitle: 'Erro',
            nzContent: errorMessage
          });
        }
      }
    });
  }

  disconectAllDevices() {
    this.modalService.confirm({
      nzTitle: 'Desconectar dispositivos',
      nzContent: 'Tem certeza que deseja desconectar todos os dispositivos?',
      nzOkText: 'Sim',
      nzCancelText: 'Cancelar',
      nzOkType: 'primary',
      nzOnOk: async () => {
        this.status = 'LOADING';
        try {
          await firstValueFrom(this.userService.deleteUserTokens(this.userId));
          this.getData();
        } catch (error) {
          this.getData();
          const errorMessage =
            error instanceof Error ? error.message : 'Não foi possível desconectar todos os dispositivos, tente novamente.';
          this.modalService.error({
            nzTitle: 'Erro',
            nzContent: errorMessage
          });
        }
      }
    });
  }

  refreshIndexChange(value: any) {
    this.nzPageIndex = --value;
    this.getData();
  }

  refreshSizeChange(value: any) {
    this.nzPageSize = value;
    this.getData();
  }
}
